import {Istanza} from "./istanza";

export interface IntegrazioneIstanzaAllDTO{
  allegati: Allegato[];
  integrazione: Integrazione;
}

export interface Integrazione{
  id: number;
  idDipendente: number;
  dataRichiesta: Date;
  dataScadenza: Date;
  nota: string;
  istanza: Istanza;
  documenti?: Array<IstanzaAllegato>;
  pagamenti?: IstanzaPagamento[];
}

export interface IstanzaAllegato {
  id: number;
  protocolloAnno: any;
  protocolloNumero: any;
  allegato: Allegato;
  tsCaricamento: Date;
  flUtente: boolean;
  createdBy: string;
  tipoIstanzaAllegato: TipoIstanzaAllegato
  dataScadenza: Date;
  provenienza: string;
  createdByDescr: string;
}

interface TipoIstanzaAllegato{
  descrizione: string,
  flObbligatorio: boolean,
  funzioneServizio: FunzioneServizio
  tipoDocumento: TipoDocumento
}

interface FunzioneServizio {
  id: string
}

export interface Allegato {
  id: string | number | undefined | null;
  descrizione: string;
  titolo: string;
  contenuto: string | null;
  fileName?: string;
  size?: number;
  tipoDoc?: TipoDocumento;
  tipo_entita?: string,
}

export interface TipoDocumento {
  id: number;
}

export interface istanzaAllegato{
  id: number,
  tsCaricamento: string,
  protocolloAnno: string,
  protocolloNumero: number,
  istanza: Istanza,
  allegato: Allegato,
  integrazione: IntegrazioneDocumento
}

export interface IntegrazioneDocumento{
  id: number,
  dataRichiesta: string,
  dataScadenza: string,
  nota: string,
  idDipendente: number,
}

export interface IstanzaPagamento{
  id: number;
  iuv: string;
  importo: number;
  stato: string;
  ricevutaPagamento: any;
  dataPagamento: string;
  dataScadenza: Date;
  idTransazione: string;
  integrazione: Integrazione,
  transazioneEsterna: string;
  avvisoPagopa: string | null;
  causale: Causale;
}

export interface Causale{
  id: number,
  descrizione: string,
  importoBloccato: boolean,
  codiceRiferimentoIntermediario: string
}
